export default __webpack_public_path__ + "static/media/kiu_striked.d5a06f59.svg";